export const formColumn = (ctx) => {
  return [
    {
      prop: 'platformCompanyCodeList',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList1,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'businessDepartmentNoList',
      name: '业务部门',
      type: 'select',
      options: ctx.departmentList,
      multiple: true,
      changeMethod: 'changeMethod',
    },
    // {
    //   name: '项目名称',
    //   prop: 'remark',
    //   type: 'input',
    // },
    {
      prop: 'projectName',
      name: '项目名称',
      searchType: 'projectListWumaoByPage',
      type: 'searchTableSpec',
      isMultiple: true,
      // currentValue: ctx.query?.projectName ? ctx.query?.projectName : null,
      // checkRowKeys: [ctx.query.projectInitiationNo ? ctx.query.projectInitiationNo : null],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        applyDepartmentNoList: (ctx.userInfo.allDepartmentList || []).map(
          (v) => v.personDepartmentCode
        ),
        // businessGroup: ctx.userInfo.businessGroup,
        //   applyCompanyNo: ctx.query.companyCode,
        // applyDepartmentNo: ctx.query.contractBusinessDepartment,
        //   platformtCompany: ctx.query.companyCode,
        // applyDepartmentName: ctx.query.contractBusinessDepartmentName,
        //   applyCompanyName: ctx.userInfo.userInfo.companyName,
        //   latformtCompanyName: ctx.userInfo.userInfo.companyName,
      },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'customerNo',
      name: '应收款单位',
      type: 'searchTableSpec',
      isMultiple: true,
      searchType: 'customer',
      extraData: {
        // companyCode: ctx.userInfo.companyCode,
        // departmentCode: ctx.query.contractBusinessDepartment,
        partnerTypes: 'HZHB01',
      },
      changeMethod: 'changeMethod',
    },
    {
      name: '出账日期',
      prop: 'accountPeriod',
      type: 'month',
      format: 'yyyy-MM',
    },
  ];
};

export const defaultTableColumn = (ctx) => {
  return [
    {
      field: 'platformCompanyName',
      title: '平台公司',
      visible: true,
    },
    {
      field: 'businessDepartmentName',
      title: '业务部门',
      visible: true,
    },
    {
      field: 'accountPeriod',
      title: '出账日期',
      visible: true,
    },
    {
      field: 'projectInitiationNo',
      title: '项目编号',
      visible: true,
    },
    {
      title: '项目名称',
      field: 'projectName',
    },
    {
      title: '应收账款单位',
      field: 'customerName',
    },
    {
      title: '合同编号',
      field: 'contractNo',
      visible: true,
    },
    {
      title: '业务日期',
      field: 'businessDate',
      visible: true,
    },
    {
      title: '回款天数',
      field: 'collectionDays',
      visible: true,
    },
    {
      title: '期末余额',
      field: 'periodEndBalance',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '总回款',
      field: 'totalCollection',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '逾期回款',
      field: 'overdueCollection',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '新增逾期',
      field: 'increaseOverdue',
      visible: true,
    },
    {
      title: '逾期总金额',
      field: 'overdueAmount',
      visible: true,
      formatter: ctx.formatterNum,
    },
    {
      title: '约定收款日期',
      field: 'expectCollectionDate',
      visible: true,
    },
    {
      title: '逾期天数',
      field: 'overdueDays',
      visible: true,
    },
    {
      title: '逾期月度',
      field: 'overdueMonthly',
      visible: true,
    },
    {
      title: '逾期月度（按账龄）',
      field: 'overdueMonthlyRange',
      visible: true,
    },
    {
      title: '是否逾期',
      field: 'overdueFlag',
      visible: true,
    },
    {
      title: '企业类型',
      field: 'enterpriseType',
      visible: true,
    },
  ];
};
// export default formColumn;
